import { useEffect, useState } from "react";
import { imageUrl, srcSet } from "../lib/images";

const POSTER = "/_assets/ny-traeterrasse-dansk-parcelhus-hero.jpg";
const VIDEO = "https://assets.auxodev.dk/assets/3fc68df7-bc32-4dbe-a468-aab3c89985d1/hero-video-1791970362490.mp4";

export default function TerraceHeroVideo() {
  const [reduceMotion, setReduceMotion] = useState(true);

  useEffect(() => {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setReduceMotion(query.matches);
    update();
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);

  return (
    <div className="absolute inset-0 bg-[#111111]" aria-hidden="true">
      <img
        src={imageUrl(POSTER, "width=1920,quality=80,format=auto")}
        srcSet={srcSet(POSTER, [640, 1280, 1920])}
        sizes="100vw"
        alt=""
        fetchPriority="high"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      {!reduceMotion && (
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster={imageUrl(POSTER, "width=1920,quality=80,format=auto")}
          className="absolute inset-0 h-full w-full object-cover object-center"
          disablePictureInPicture
          tabIndex={-1}
        >
          <source src={VIDEO} type="video/mp4" />
        </video>
      )}
    </div>
  );
}
